import DAR from '../../../../app/public/assets/Centros/501.webp';
import FUTURE from '../../../../app/public/assets/Centros/504.png';
import CLA from '../../../../app/public/assets/Centros/507.png';
import SCANCENTER from '../../../../app/public/assets/Centros/511.webp';
import HNORTE from '../../../../app/public/assets/Centros/512.webp';
import DIAGNOS from '../../../../app/public/assets/Centros/517.png';
import LONDRES from '../../../../app/public/assets/Centros/518.png';
import SSUCBBA from '../../../../app/public/assets/Centros/519.webp';
import CEMES from '../../../../app/public/assets/Centros/525.png';
import BELGA from '../../../../app/public/assets/Centros/526.png';
import ONCOSUR from '../../../../app/public/assets/Centros/528.webp';
import MEDCENT from '../../../../app/public/assets/Centros/532.png';
import RESOMEDICA from '../../../../app/public/assets/Centros/534.webp';
import VENTURA from '../../../../app/public/assets/Centros/535.png';
import COSSMIL from '../../../../app/public/assets/Centros/509.webp';

import SDAR from '../../../../app/public/assets/Centros/501-small.png';
import SFUTURE from '../../../../app/public/assets/Centros/504-small.png';
import SCLA from '../../../../app/public/assets/Centros/507-small.png';
import SSCANCENTER from '../../../../app/public/assets/Centros/511-small.png';
import SHNORTE from '../../../../app/public/assets/Centros/512-small.png';
import SDIAGNOS from '../../../../app/public/assets/Centros/517-small.png';
import SLONDRES from '../../../../app/public/assets/Centros/518-small.png';
import SSSUCBBA from '../../../../app/public/assets/Centros/519-small.png';
import SCEMES from '../../../../app/public/assets/Centros/525-small.png';
import SBELGA from '../../../../app/public/assets/Centros/526-small.png';
import SONCOSUR from '../../../../app/public/assets/Centros/528-small.png';
import SMEDCENT from '../../../../app/public/assets/Centros/532-small.png';
import SRESOMEDICA from '../../../../app/public/assets/Centros/534-small.png';
import SVENTURA from '../../../../app/public/assets/Centros/535-small.png';
import SCOSSMIL from '../../../../app/public/assets/Centros/509-small.webp';

export const clientLogos: Record<string, string> = {
  501: DAR,
  504: FUTURE,
  507: CLA,
  509: COSSMIL,
  511: SCANCENTER,
  512: HNORTE,
  517: DIAGNOS,
  518: LONDRES,
  519: SSUCBBA,
  525: CEMES,
  526: BELGA,
  528: ONCOSUR,
  532: MEDCENT,
  534: RESOMEDICA,
  535: VENTURA,
};

export const clientLogosSmall: Record<string, string> = {
  501: SDAR,
  504: SFUTURE,
  507: SCLA,
  509: SCOSSMIL,
  511: SSCANCENTER,
  512: SHNORTE,
  517: SDIAGNOS,
  518: SLONDRES,
  519: SSSUCBBA,
  525: SCEMES,
  526: SBELGA,
  528: SONCOSUR,
  532: SMEDCENT,
  534: SRESOMEDICA,
  535: SVENTURA,
};
